import { Pill } from "@/components/ui/pill";
import { formatRelative } from "@/lib/format";
import type { Connection } from "./types";

export function ConnectionStatus({ connection: c, checking }: { connection: Connection; checking: boolean }) {
  if (checking)
    return (
      <Pill tone="run" dot>
        Checking
      </Pill>
    );
  if (!c.last_checked_at) return <span className="text-muted">Not checked</span>;
  const ok = c.last_check_error === null;
  return (
    <div className="flex flex-col gap-1">
      <span className="flex items-center gap-2">
        <Pill tone={ok ? "run" : "err"}>{ok ? "Connected" : "Failed"}</Pill>
        <span className="text-xs text-muted">{formatRelative(c.last_checked_at)}</span>
      </span>
      {!ok && <span className="text-xs text-err">{c.last_check_error}</span>}
    </div>
  );
}
